export const METHODS = {
  post: 'POST',
  get: 'GET',
  update: 'UPDATE',
  delete: 'DELETE',
  put: 'PUT',
  patch: 'PATCH'
};

export enum WIDGET_LAYOUT {
  carousel = 'carousel',
  grid = 'grid'
}

export enum WIDGET_TITLE_SIZE {
  small = 'small',
  medium = 'medium',
  large = 'large'
}

export enum WIDGET_TITLE_WEIGHT {
  regular = 'regular',
  medium = 'medium',
  bold = 'bold'
}

export enum WIDGET_CARD_RADIUS {
  none = 'none',
  small = 'small',
  medium = 'medium',
  large = 'large'
}

export const CARD_WIDTH = 214;
